import { IEntity } from "@odata/BindingContext";
import { CustomerPermissionCode, UserPermissionCode } from "@odata/CompanyPermissionEnums";
import { CompanyPermissionCode, GeneralPermissionCode } from "@odata/GeneratedEnums";
import { isEntityOwner } from "@pages/admin/users/Users.utils";

import { IPermissionContext } from "../contexts/permissionContext/PermissionContext";
import { Model } from "../model/Model";
import { TableStorage } from "../model/TableStorage";
import { FormStorage } from "../views/formView/FormStorage";

type TorArrayOfT<T> = T | T[];

export interface IPermissionSettings {
    GPs?: TorArrayOfT<GeneralPermissionCode>;
    CPs?: TorArrayOfT<UserPermissionCode | CustomerPermissionCode>;
    allowReadonlyPermissionBypass?: boolean;
    // cases when content has only customer permission and is always available to accountant even with no permission at all
    allowedForAccountant?: boolean;
}

export const canUnlock = (storage: FormStorage | TableStorage, generalPermissions: Set<GeneralPermissionCode>, entity: IEntity): boolean => {
    return generalPermissions.has(GeneralPermissionCode.Unlocking) ||
            entity[storage.data.definition.lockProperty]?.every?.((lock: IEntity) => lock.CreatedBy?.Id === storage.context.getData()?.userSettings?.Id);
};

export function checkPermissionWithOwnPermission(storage: Model, permissionContext: IPermissionContext, permission: CompanyPermissionCode): boolean {
    return permissionContext.ownOnlyPermissions.has(permission) ? isEntityOwner(storage.context, storage.data.entity)
        : permissionContext.hasCompanyPermissions(permission);
}

export function hasAllPermissions(context: IPermissionContext, settings: IPermissionSettings): boolean {
    if (!settings) {
        return true;
    }
    const { GPs, CPs } = settings;

    if (GPs && !(Array.isArray(GPs) ? GPs : [GPs]).every(perm => context.generalPermissions.has(perm))) {
        return false;
    }

    if (settings.allowedForAccountant && !context.userIsCustomer) {
        return true;
    }

    return context.hasCompanyPermissions(CPs);
}
